import gql from "graphql-tag";

export default gql`
  mutation changeSourceDisabled($sourceId: ID, $disabled: Boolean) {
    changeSourceDisabled(sourceId: $sourceId, disabled: $disabled) {
      id
      disabled
    }
  }
`;
